import * as types from "../constants/actionTypes";
import { getAddons } from "../api/addons";

import { generateAsyncAction } from "./generateAsyncAction";

export const onAddonAdd = (groupId, addonCode, msg = "") => {
  return {
    type: types.ADDON_ADDED,
    payload: {
      groupId,
      addonCode,
      msg
    }
  };
};

export const onAddonRemove = (groupId, addonCode) => {
  return {
    type: types.ADDON_REMOVED,
    payload: {
      groupId,
      addonCode
    }
  };
};

export const onCancelAddons = groupId => {
  return {
    type: types.ADDONS_CANCELED,
    payload: {
      groupId
    }
  };
};

export const getAddonsResult = request => async dispatch => {
  dispatch({ type: types.GET_ADDONS_REQUEST });
  const getAddonsAction = await generateAsyncAction({
    onFailAction: addonsFailed,
    onSuccessAction: addonsSuccess,
    asyncApiMethod: getAddons,
    request
  });
  return dispatch(getAddonsAction);
};

// const addonsSuccess = ({ payload }) => ({
//     type: types.GET_ADDONS_SUCESS,
//     payload
// });

const addonsSuccess = ({ payload }) => dispatch => {
  const { addonImagesLookupTable, addonsGroups } = payload;
  dispatch({
    type: types.GET_ADDONS_SUCESS,
    payload: addonsGroups
  });

  dispatch({
    type: types.GET_ADDONS_IMAGES_SUCESS,
    payload: addonImagesLookupTable
  });
};

const addonsFailed = ({ message, title }) => ({
  type: types.GET_ADDONS_FAIL,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});

export const setAddonsForOrder = addons => {
  return {
    type: types.SET_ADDONS_FOR_ORDER,
    payload: addons
  };
};

export const setAddonsCurosselRoomNum = roomNum => {
  return {
    type: types.SET_ADDONS_CUROSSEL_ROOM_NUMBER,
    payload: roomNum
  };
};



// WEBPACK FOOTER //
// ./src/actions/addonsActions.js